// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  onNativeGeometryReaderChange?: DirectEventHandler<Readonly<{
    x: Double;
    y: Double;
    width: Double;
    height: Double;
    localX: Double;
    localY: Double;
    localWidth: Double;
    localHeight: Double;
    sizeWidth: Double;
    sizeHeight: Double;
    safeAreaTop: Double;
    safeAreaLeading: Double;
    safeAreaBottom: Double;
    safeAreaTrailing: Double;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeGeometryReader';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeGeometryReader",
  directEventTypes: {
    topNativeGeometryReaderChange: {
      registrationName: "onNativeGeometryReaderChange"
    }
  },
  validAttributes: {
    ...ConditionallyIgnoredEventHandlers({
      onNativeGeometryReaderChange: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);